var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import classNames from "classnames";
import React, { PureComponent } from "react";
import Button from "./Button.mjs";
import { F as FormConsumer } from "./context-jqLAdImf.mjs";
const EyeClosed = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'?%3e%3csvg%20width='24px'%20height='24px'%20viewBox='0%200%2024%2024'%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3c!--%20Generator:%20Sketch%2060.1%20(88133)%20-%20https://sketch.com%20--%3e%3ctitle%3eGraphic%20/%20Icon%20/%20Toggle%20/%20Password%20/%20Eyeclosed%20/%20Outline%3c/title%3e%3cdesc%3eCreated%20with%20Sketch.%3c/desc%3e%3cg%20id='Graphic-/-Icon-/-Toggle-/-Password-/-Eyeclosed-/-Outline'%20stroke='none'%20stroke-width='1'%20fill='none'%20fill-rule='evenodd'%3e%3cpath%20d='M22.0691135,2.23060211%20C22.3559696,2.52941052%2022.3462803,3.00418539%2022.0474719,3.29104147%20L3.29747186,21.2910415%20C2.99866345,21.5778975%202.52388858,21.5682083%202.2370325,21.2693999%20C1.95017643,20.9705914%201.95986571,20.4958166%202.25867412,20.2089605%20L21.0086741,2.20896049%20C21.3074825,1.92210441%2021.7822574,1.9317937%2022.0691135,2.23060211%20Z%20M20.190272,8.02422163%20C21.3454705,8.86745278%2022.4128736,9.82478427%2023.3793353,10.8850455%20C24.2061366,11.8029446%2024.2061366,13.1970534%2023.3771533,14.1173688%20C20.1931028,17.6215615%2015.8947272,20.0656852%2012.0036722,19.9999803%20C10.8972833,20.0082393%209.79626515,19.8454077%208.73963016,19.5172546%20C8.34405423,19.3944028%208.12296763,18.9741341%208.24581942,18.5785581%20C8.3686712,18.1829822%208.7889399,17.9618956%209.18451583,18.0847474%20C10.0935075,18.3670478%2011.0406812,18.5071271%2012.0106939,18.5001074%20C15.4171423,18.5574354%2019.3458036,16.323537%2022.2648109,13.1110469%20C22.5776448,12.763743%2022.5776448,12.2362578%2022.2677972,11.8922511%20C21.3721138,10.9096557%2020.3798156,10.0196843%2019.3058983,9.23578395%20C18.9713346,8.99157092%2018.898091,8.52237967%2019.142304,8.18781597%20C19.386517,7.85325227%2019.8557083,7.78000859%2020.190272,8.02422163%20Z%20M15.7480731,11.749001%20C16.1622867,11.749001%2016.4980731,12.0847874%2016.4980731,12.499001%20C16.4980731,14.9852845%2014.4833567,17.000001%2011.9980731,17.000001%20C11.5829595,17.0000562%2011.2471282,16.6643146%2011.247073,16.250101%20C11.2470178,15.8358874%2011.5827594,15.5000562%2011.996973,15.500001%20C13.6549296,15.500001%2014.9980731,14.1568574%2014.9980731,12.500001%20C14.9980731,12.0847874%2015.3338596,11.749001%2015.7480731,11.749001%20Z%20M11.9896632,5.00004827%20C12.8665845,4.9902141%2013.7411679,5.09242379%2014.592185,5.30419714%20C14.99414,5.40422257%2015.2389023,5.81115807%2015.1388768,6.21311303%20C15.0388514,6.61506799%2014.6319159,6.85983024%2014.2299609,6.75980482%20C13.5028911,6.57887542%2012.7556866,6.49155207%2011.9856093,6.49989753%20C8.60744988,6.44374852%204.65782345,8.67124297%201.73433633,11.8869555%20C1.42150241,12.2342594%201.42150242,12.7617446%201.73081517,13.105165%20C2.49900724,13.9461091%203.33745211,14.7200616%204.23705554,15.4186265%20C4.56421441,15.6726736%204.62348318,16.1438342%204.36943604,16.470993%20C4.1153889,16.7981519%203.64422834,16.8574207%203.31706947,16.6033735%20C2.35016416,15.8525471%201.44899339,15.0206935%200.619811955,14.1129568%20C-0.206989442,13.1950578%20-0.206989457,11.8009489%200.622127172,10.8804869%20C3.81107818,7.37276249%208.13239195,4.93564531%2011.9896632,5.00004827%20Z%20M11.9970727,8.00000139%20C12.4130868,7.99989106%2012.7489627,8.33558801%2012.7490731,8.74980156%20C12.7491835,9.16401511%2012.4134865,9.49989101%2011.999273,9.50000139%20C10.3407663,9.50000139%208.99807286,10.842695%208.99807286,12.4990014%20C8.99807286,12.9142145%208.66228642,13.250001%208.24807286,13.250001%20C7.8338593,13.250001%207.49807286,12.9142145%207.49807286,12.5000014%20C7.49807286,10.014268%209.51233918,8.00000139%2011.9970727,8.00000139%20Z'%20id='Icon'%20fill='%2369696E'%20fill-rule='nonzero'%3e%3c/path%3e%3c/g%3e%3c/svg%3e";
const EyeOpen = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'?%3e%3csvg%20width='24px'%20height='24px'%20viewBox='0%200%2024%2024'%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3c!--%20Generator:%20Sketch%2060.1%20(88133)%20-%20https://sketch.com%20--%3e%3ctitle%3eGraphic%20/%20Icon%20/%20Toggle%20/%20Password%20/%20Eyeopen%20/%20Outline%3c/title%3e%3cdesc%3eCreated%20with%20Sketch.%3c/desc%3e%3cg%20id='Graphic-/-Icon-/-Toggle-/-Password-/-Eyeopen-/-Outline'%20stroke='none'%20stroke-width='1'%20fill='none'%20fill-rule='evenodd'%3e%3cpath%20d='M11.9980963,5.00108244%20C15.8735435,4.94115317%2020.1889135,7.37542611%2023.3793569,10.8832246%20C24.2061582,11.8011237%2024.2061582,13.1952325%2023.3771748,14.1155479%20C20.1931244,17.6197406%2015.8947488,20.0638643%2012.0107154,19.9980741%20C8.10120114,20.0638684%203.80317678,17.6192917%200.619833674,14.113136%20C-0.206967723,13.1952369%20-0.206967738,11.8011281%200.621974785,10.8808576%20C3.80565185,7.37650497%208.12208855,4.94114441%2011.9980963,5.00108244%20Z%20M12.0107454,6.50107358%20L11.9854451,6.50107354%20C8.60632929,6.44407035%204.65609311,8.67111811%201.73435805,11.8871346%20C1.42152413,12.2344385%201.42152414,12.7619237%201.73237051,13.1070281%20C4.65084608,16.3214489%208.57893105,18.5556161%2012.0107154,18.4982865%20C15.4171638,18.5556145%2019.3458251,16.3217161%2022.2648325,13.1092259%20C22.5776663,12.7619221%2022.5776663,12.2344368%2022.2672621,11.8898189%20C19.3389952,8.67028762%2015.389454,6.44407725%2012.0107454,6.50107358%20Z%20M11.9966952,7.99917969%20C14.4814303,7.99785443%2016.4967752,10.0110486%2016.4980954,12.49578%20C16.4980954,14.9844638%2014.4833789,16.9991797%2011.9980954,16.9991797%20C9.51281181,16.9991797%207.49809537,14.9844638%207.49809537,12.4991797%20C7.49809537,10.0143639%209.51208096,7.99984026%2011.9966952,7.99917969%20Z%20M11.9972946,9.49917977%20C10.3407514,9.49962021%208.99809537,10.8426349%208.99809537,12.4991798%20C8.99809537,14.1560367%2010.3412389,15.4991798%2011.9980954,15.4991798%20C13.5957784,15.4991798%2014.9017564,14.2502623%2014.9930027,12.6754528%20L14.9980955,12.4991802%20C14.9972155,10.8402748%2013.6538033,9.49829628%2011.9972946,9.49917977%20Z'%20id='Icon'%20fill='%2369696E'%20fill-rule='nonzero'%3e%3c/path%3e%3c/g%3e%3c/svg%3e";
class Input extends PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      touched: false,
      error: "",
      id: this.props.id || this.getElementId(),
      passwordVisible: false
    });
    __publicField(this, "input", React.createRef());
    __publicField(this, "getRef", () => {
      return this.input.current;
    });
    __publicField(this, "getError", (onChangeString) => {
      const { value, required, requiredErrorMessage, onValidate } = this.props;
      const stringValue = onChangeString ? onChangeString : value;
      if (!stringValue && required) {
        this.setState({ error: requiredErrorMessage ?? "This field is required." });
      } else if (stringValue && onValidate) {
        this.setState({ error: onValidate(stringValue) });
      }
    });
    __publicField(this, "onBlur", () => {
      const { onBlur } = this.props;
      this.getError();
      if (onBlur)
        onBlur();
    });
    __publicField(this, "onChange", (value) => {
      var _a, _b;
      this.setState({ error: "" });
      if (this.props.validateOnChange)
        this.getError(value);
      (_b = (_a = this.props).onChange) == null ? void 0 : _b.call(_a, value);
    });
    __publicField(this, "togglePasswordVsisible", () => {
      this.setState({
        passwordVisible: !this.state.passwordVisible
      });
    });
    __publicField(this, "setInputType", (type) => {
      const { passwordVisible } = this.state;
      switch (type) {
        case "password":
          return passwordVisible ? "text" : "password";
        default:
          return type;
      }
    });
    __publicField(this, "onKeyPress", (e, preventDefaultOnEnterKey) => {
      var _a, _b;
      if (e.key.toLowerCase() === "enter") {
        if (preventDefaultOnEnterKey) {
          e.preventDefault();
        }
        (_b = (_a = this.props).onSubmit) == null ? void 0 : _b.call(_a, e.target.value);
      }
    });
  }
  componentDidMount() {
    var _a, _b;
    (_b = (_a = this.props).attachToForm) == null ? void 0 : _b.call(_a, this);
  }
  componentWillUnmount() {
    var _a, _b;
    (_b = (_a = this.props).removeFromForm) == null ? void 0 : _b.call(_a, this);
  }
  isValid() {
    var _a;
    const { value, required, onValidate } = this.props;
    if (this.state.error)
      return false;
    if (!value && required) {
      return false;
    }
    if (onValidate)
      return !onValidate(value);
    return !!((_a = this.input.current) == null ? void 0 : _a.validity.valid);
  }
  hasError() {
    const { touched } = this.state;
    if (!touched)
      return false;
    return !this.isValid();
  }
  touch() {
    this.setState({ touched: true });
  }
  reset() {
    this.setState({ touched: false });
  }
  focus() {
    var _a;
    (_a = this.input.current) == null ? void 0 : _a.focus();
  }
  getElementId() {
    return "id-" + Math.floor(Math.random() * 1e4);
  }
  render() {
    const {
      onValidate,
      showError,
      label,
      className,
      textarea,
      onChange,
      onSubmit: _onSubmit,
      attachToForm,
      removeFromForm,
      onBlur,
      type,
      disabled,
      id,
      name,
      required,
      placeholder,
      icon,
      autoFocus,
      title,
      preventDefaultOnEnterKey,
      hideLabel,
      requiredErrorMessage,
      validateOnChange,
      maxLength,
      ...others
    } = this.props;
    const { error, passwordVisible } = this.state;
    const inputClasses = classNames({
      input: true,
      disabled,
      [className]: !!className,
      error: !!error
    });
    return /* @__PURE__ */ jsxs("div", { className: inputClasses, children: [
      label && /* @__PURE__ */ jsxs(
        "label",
        {
          className: classNames({ "input-label-hidden": hideLabel }),
          htmlFor: this.state.id,
          children: [
            label,
            required && /* @__PURE__ */ jsx("span", { "aria-hidden": "true", children: "*" })
          ]
        }
      ),
      textarea ? /* @__PURE__ */ jsx(
        "textarea",
        {
          id: this.state.id || id,
          title,
          "aria-label": title,
          placeholder,
          disabled,
          ref: this.input,
          onBlur: this.onBlur,
          maxLength,
          onChange: (e) => this.onChange(e.target.value),
          onKeyDown: (e) => this.onKeyPress(e, preventDefaultOnEnterKey),
          autoFocus,
          ...others
        }
      ) : /* @__PURE__ */ jsxs("div", { className: "inner-input", children: [
        icon ? /* @__PURE__ */ jsxs("div", { className: "input-icon", children: [
          /* @__PURE__ */ jsx(
            "input",
            {
              title,
              "aria-label": title,
              placeholder,
              id: this.state.id || id,
              disabled,
              type: this.setInputType(type),
              maxLength,
              ref: this.input,
              onChange: (e) => this.onChange(e.target.value),
              onBlur: this.onBlur,
              onKeyDown: (e) => this.onKeyPress(e, preventDefaultOnEnterKey),
              required,
              className: "input",
              ...others
            }
          ),
          /* @__PURE__ */ jsx("img", { src: icon, alt: "input-icon", className: "icon-img" })
        ] }) : /* @__PURE__ */ jsx(
          "input",
          {
            title,
            "aria-label": title,
            placeholder,
            id: this.state.id || id,
            disabled,
            type: this.setInputType(type),
            maxLength,
            ref: this.input,
            onChange: (e) => this.onChange(e.target.value),
            onBlur: this.onBlur,
            onKeyDown: (e) => this.onKeyPress(e, preventDefaultOnEnterKey),
            required,
            autoFocus,
            ...others
          }
        ),
        type === "password" ? /* @__PURE__ */ jsx(
          Button,
          {
            className: "password-visibility",
            onClick: this.togglePasswordVsisible,
            type: "button",
            children: passwordVisible ? /* @__PURE__ */ jsx("img", { src: EyeOpen, alt: "See password", title: "See password" }) : /* @__PURE__ */ jsx(
              "img",
              {
                src: EyeClosed,
                alt: "Hide password",
                title: "Hide password"
              }
            )
          }
        ) : null
      ] }),
      /* @__PURE__ */ jsx("div", { "aria-live": "assertive", "aria-atomic": true, className: "input-error", children: error && showError && /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("span", { className: "only-visible-to-screen-readers", children: `Error for input ${label}: ` }),
        error
      ] }) })
    ] });
  }
}
__publicField(Input, "defaultProps", {
  type: "text",
  className: ""
});
const forwardRef = React.forwardRef((props, ref) => /* @__PURE__ */ jsx(FormConsumer, { children: (context) => /* @__PURE__ */ jsx(
  Input,
  {
    ...props,
    ref,
    attachToForm: context && context.attachToForm,
    removeFromForm: context && context.removeFromForm
  }
) }));
export {
  Input,
  forwardRef as default
};
